import {
    Dialog,
    DialogContent,
    DialogTitle,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText
} from '@mui/material'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { dashboardCreateOptions } from '@/routeConfig'

export function CreateModal({ open, onClose, pathPrefix }) {
    const navigate = useNavigate()

    const options = pathPrefix
        ? dashboardCreateOptions.filter(
              (option) => option.pathPrefix === pathPrefix
          )
        : dashboardCreateOptions

    if (options.length === 0) {
        return null
    }

    const handleSelect = (path) => {
        navigate(path)
        onClose()
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>What do you want to create?</DialogTitle>
            <DialogContent sx={{ p: 0 }}>
                <List>
                    {options.map((option) => (
                        <ListItemButton
                            key={option.id}
                            onClick={() => handleSelect(option.path)}
                        >
                            <ListItemIcon>{option.icon}</ListItemIcon>
                            <ListItemText primary={option.label} />
                        </ListItemButton>
                    ))}
                </List>
            </DialogContent>
        </Dialog>
    )
}

CreateModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    pathPrefix: PropTypes.string
}
